import React, { FC } from 'react'

import { ProfileHit } from 'common/constants'
import { SmallNoteText } from 'components/block/PhotoLine/PhotoLineTooltip.styled'
import { ProfileLink } from 'components/presentational/ProfileLink/ProfileLink'
import { PresentVipName } from 'components/presentational/ProfileName/ProfileName'

export const PresentVipTitle: FC<{
  profileId: number
  name: string
  age: number | null | undefined
  isOnline: boolean | undefined
  isVerifiedPhotos: boolean
  location: string
}> = ({ profileId, name, age, isOnline, isVerifiedPhotos, location }) => {
  return (
    <ProfileLink
      id={profileId}
      data-name="link-present-vip-action"
      hit={ProfileHit.GIFT_HIT}
    >
      <PresentVipName
        fullName={name}
        age={age}
        online={isOnline}
        statusVerification={isVerifiedPhotos}
      />
      <SmallNoteText>{location}</SmallNoteText>
    </ProfileLink>
  )
}
